
import React, { useRef, useState } from "react";
import "../styles/NewNavBar.css";
import logo from "../icons/Alesta_Logo-removebg-preview.png"
import image1 from "../icons/entryImage2.jpg"
import { useTranslation } from "react-i18next";
import entryImg from "../icons/header2.webp"

const NewNavbar = () => {
    // Desktop Navigation
    const desktopNavElement = useRef(null);
    const searchContainerElement = useRef(null);
    const overlayElement = useRef(null);
    const { t, i18n } = useTranslation();

    const addSearch = () => {
        desktopNavElement.current.classList.add("hide");
        searchContainerElement.current.classList.remove("hide");
        overlayElement.current.classList.add("show");
    };

    const addClose = () => {
        desktopNavElement.current.classList.remove("hide");
        searchContainerElement.current.classList.add("hide");
        overlayElement.current.classList.remove("show");
    };

    const addOverlay = () => {
        desktopNavElement.current.classList.remove("hide");
        searchContainerElement.current.classList.add("hide");
        overlayElement.current.classList.remove("show");
    };

    // Mobile Navigation

    const navContainerElement = useRef(null);
    const searchBarElement = useRef(null);
    const navElement = useRef(null);

    const addMobMenu = () => {
        navContainerElement.current.classList.toggle("active");
    };

    const addMobSearch = () => {
        searchBarElement.current.classList.add("active");
        navElement.current.classList.add("move-up");
        desktopNavElement.current.classList.add("move-down");
    };

    const addMobCancel = () => {
        searchBarElement.current.classList.remove("active");
        navElement.current.classList.remove("move-up");
        desktopNavElement.current.classList.remove("move-down");
    };

    const [count, setCount] = useState("0");
    function openCloseCount() {
        if (count === "1") {
            setCount("0")
            addClose();
        } else {
            setCount("1")
        }
    }


    return (
        <>
        <section id="pageEntry">
            <div className="nav-container" ref={navContainerElement}>
                <nav ref={navElement}>
                    <ul className="mobile-nav">
                        <li>
                        <div className="mobileLogoDiv">
                                   <img className="logo2" src={logo} alt="Alesta Innovation Logo"></img>   
                                </div>
                            <div className="menu-icon-container"  onClick={() => addMobMenu()} >

                                <div className="menu-icon">
                                    <span className="line-1"></span>
                                    <span className="line-2"></span>
                                   
                                </div>
                            
                              
                            </div>
                        </li>

                        <li>
                            <a href="#" className="link-logo"></a>

                        </li>

                    </ul>

                    <div className="navDesktop">
                        <ul className="desktop-nav" ref={desktopNavElement}>
                            <div className="logo-li-div">
                        
                            <li id="logoContainer">

                                <div className="logo-div">
                                  <a id="pageEntryImage"  href='#pageEntry'>
                                    <img className="logo" src={logo} alt="Alesta Innovation Logo"></img>
                                    </a>
                                </div>
                            </li>
                            </div>
                           
                            {/* <li onClick={() => addMobMenu()} id="homeContainer">
                                <a className="navbar-item" href='#entryPage'>{t("homeHeader")}</a>
                            </li> */}
                            <div className="header-li-div">
                            
                           
                            <li onClick={() => addMobMenu()} id="announcementsContainer">
                                <a className="navbar-item" href='#announcements'>{t("announcementHeader")}</a>

                            </li>
                           
                            <li onClick={() => addMobMenu()} id="resourceContainer">
                                <a className="navbar-item" href='#resource'>{t("resourceHeader")}</a>

                            </li>
                            {/* <li onClick={() => addMobMenu()} id="externalContainer">
                                <a className="navbar-item" href='#external'>{t("externalHeader")}</a>

                            </li > */}
                             <li onClick={() => addMobMenu()} id="teammateContainer">
                                <a className="navbar-item" href='#teammate'>{t("team")}</a>

                            </li>
                            <li onClick={() => addMobMenu()} id="faqContainer">
                                <a className="navbar-item" href='#sss'>{t("faqNav")}</a>

                            </li>
                            <li onClick={() => addMobMenu()} id="contactContainer">
                                <a className="navbar-item" href='#contact'>{t("contactHeader")}</a>

                            </li>
                            {/* Real links (not a JS toggle) so crawlers can follow both languages. */}
                            <li className="lang-switch">
                                <a className="navbar-item" href="/" hrefLang="tr" lang="tr" aria-label={t("languageTurkish")} aria-current={i18n.language === "tr" ? "page" : undefined}>TR</a>
                                <span aria-hidden="true">|</span>
                                <a className="navbar-item" href="/en/" hrefLang="en" lang="en" aria-label={t("languageEnglish")} aria-current={i18n.language === "en" ? "page" : undefined}>EN</a>
                            </li>
                            </div>
                            

                        </ul>
                    </div>

                </nav>

            </div>

            {/* <div className="containerEntryPage">
                <div className="imageContainer"  >
                    <img className="image1" src={image1} >
                    
                     </img>

                     <p className="entryPrg">Finans sektörüne özel yazılım çözümlerimizle yenilikçi bir iz bırakın!</p>
                    
                   
                </div>
              

            </div> */}
 <div className="entryPageGeneral">
            <div className="generalEntryPage">

            <div className="entryPageImg1">
                        <img className="imgEntry" src={entryImg} alt={t("heroAlt")}></img>
                    </div>

                    <div className="writeEntryPage">
                           <h1 className="entryPageHead">{t("heroTitle")}</h1>
                           <p className="entryPagePrg">{t("heroText")}</p>
                    </div>

                    <div className="entryPageImg">
                        <img className="imgEntry" src={entryImg} alt={t("heroAlt")}></img>
                    </div>
          
            </div>
</div>
            <div
                className="overlay"
                ref={overlayElement}
                onClick={() => addOverlay()}
            ></div>
            </section>
        </>
    );
};

export default NewNavbar;